
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // 自动重定向到搜索页面
    navigate('/search');
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">正在跳转到系统首页...</p>
      </div>
    </div>
  );
}
